import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';

import screenOptions from '../config/screenOptions';
import {
  ConfirmDatesPersonal, ClassData, AlterPic, Evaluation, PlansPersonal,
  rescheduleClass, SelectDates, SelectPersonal, selectTargets, SignUpTrainer,
  PersonalAlterPassword, ConfirmedSubscription, HowItWorksLivePersonalTrainer, SignUpGroup, ClassesByTenant,
} from '../screens/trainer';

const Stack = createStackNavigator();
const PersonalTrainerNavigator = () => (
  <Stack.Navigator screenOptions={screenOptions}>
    <Stack.Screen name="Class Data" component={ClassData} />
    <Stack.Screen name="Alter Pic" component={AlterPic} />
    <Stack.Screen name="Personal Alter Password" component={PersonalAlterPassword} />

    <Stack.Screen name="Class Re-Schedule" component={rescheduleClass} />
    <Stack.Screen name="Evaluation" component={Evaluation} />
    <Stack.Screen name="Subscriptions" component={PlansPersonal} />
    <Stack.Screen name="Grupo" component={SignUpGroup} />
    <Stack.Screen name="Cadastro Personal Trainer" component={SignUpTrainer} />
    <Stack.Screen name="Selecione os Objetivos" component={selectTargets} />
    <Stack.Screen name="Como Funciona PF" component={HowItWorksLivePersonalTrainer} />
    <Stack.Screen name="Selecione o Personal" component={SelectPersonal} />
    <Stack.Screen name="Selecione as datas" component={SelectDates} />
    <Stack.Screen name="Confirmação Personal Trainer" component={ConfirmDatesPersonal} />
    <Stack.Screen name="Confirmed Subscription" component={ConfirmedSubscription} />
    <Stack.Screen name="Class Tenant" component={ClassesByTenant} />
  </Stack.Navigator>
);

export default PersonalTrainerNavigator;
